import React from 'react'
import { IStepFields } from '../../../../../interface/MedicalRecord'
import { RecordValueRenderer } from '../../../PatientMedicalRecords/RecordValueRenderer'

const RepeaterRender = ({ field }: { field: IStepFields }) => {
    return (
        <>
            <h2 className='font-bold mb-2 text-sm'>
                {field?.Value}
            </h2>
            <div className='col-span-2'>{field?.RepeatedGroups?.map((item, index) => {

                const hasValue = item?.filter((i: any) => {
                    return i?.Value
                })?.length > 0
                return item?.length > 0 && hasValue ?
                    <div key={index} className="box m-2">
                        <h2 className='font-bold border mb-2 text-sm bg-Gray w-6 h-6 flex items-center justify-center p-2 rounded-full'>
                            {index + 1}</h2>
                        {item?.map((childField: IStepFields) => {

                            const childHasValue =
                                (childField?.Value !== null &&
                                    childField?.Value?.length > 0 &&
                                    childField?.Value !== undefined &&
                                    childField?.Value !== "") ||
                                childField?.Selected;
                            if (childHasValue) {
                                return (
                                    <div key={childField.Id} className="flex flex-col gap-1">
                                        <RecordValueRenderer field={childField} />
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div> : <></>

            })}</div>
        </>
    )
}

export default RepeaterRender